import axios from "axios";
const accessToken = localStorage.getItem("@user");

const API_BASE_URL = "https://htprdapi.hightable.ai";

export const sendNotification = async () => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/users/notification?access_token=${accessToken}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error sending notification:", error);
    throw error.response ? error.response.data : error.message;
  }
};
